<template>
  <div :class="$style.page">
    <div :class="$style.sheet">
      <div :class="$style.header">
        <button
          :class="[$style.tab, activeTab === 'hours' && $style.tabActive]"
          @click="activeTab = 'hours'"
        >
          Часы
        </button>
        <button
          :class="[$style.tab, activeTab === 'days' && $style.tabActive]"
          @click="activeTab = 'days'"
        >
          Дни
        </button>
      </div>

      <div :class="$style.list">
        <div v-if="activeTab === 'hours'">
          <label v-for="h in hours" :key="'h' + h">
            <div :class="$style.row">
              <input
                type="radio"
                name="delivery_time_hours"
                :value="h"
                v-model="selectedHour"
                :class="$style.vh"
              />
              <span
                :class="[$style.radio, selectedHour === h && $style.radioOn]"
              >
                <span v-if="selectedHour === h" :class="$style.dot"></span>
              </span>
              <span :class="$style.rowText">
                {{ h }} {{ plural(h, "час", "часа", "часов") }}
              </span>
            </div>
          </label>
        </div>

        <div v-else>
          <label v-for="d in days" :key="'d' + d">
            <div :class="$style.row">
              <input
                type="radio"
                name="delivery_time_days"
                :value="d"
                v-model="selectedDay"
                :class="$style.vh"
              />
              <span
                :class="[$style.radio, selectedDay === d && $style.radioOn]"
              >
                <span v-if="selectedDay === d" :class="$style.dot"></span>
              </span>
              <span :class="$style.rowText">
                {{ d }} {{ plural(d, "день", "дня", "дней") }}
              </span>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeliveryPicker",
  data() {
    return {
      activeTab: "hours",
      selectedHour: null,
      selectedDay: null,
      hours: Array.from({ length: 24 }, (_, i) => i + 1),
      days: Array.from({ length: 30 }, (_, i) => i + 1),
      mbHandler: null,
    }
  },
  computed: {
    canChoose() {
      return Boolean(this.selectedHour || this.selectedDay)
    },
  },
  methods: {
    plural(n, one, few, many) {
      const n10 = n % 10,
        n100 = n % 100
      if (n10 === 1 && n100 !== 11) return one
      if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return few
      return many
    },
    updateMB() {
      const mb = window.Telegram?.WebApp?.MainButton
      if (!mb) return
      mb.setText("Выбрать")
      if (this.canChoose) {
        mb.textColor = "#ffffff"
        mb.color = "#eb5a0a"
        mb.enable()
      } else {
        mb.textColor = "#B9B9BB"
        mb.color = "#E8E8EA"
        mb.enable()
      }
    },
    applyAndBack() {
      if (!this.canChoose) return
      const returnTo = this.$route?.query?.returnTo
      const query =
        this.selectedHour != null
          ? { hours: this.selectedHour }
          : { days: this.selectedDay }
      Object.keys(query).forEach((key) => {
        const value = query[key]
        // Для регистрации используем store.userInfoUpdate, для редактирования - нет
        if (returnTo !== "EditDeliveryTime" && returnTo !== "BecomeSeller") {
          this.$store.commit("changeUserInfoUpdate", { delivery_type: key })
          this.$store.commit("changeUserInfoUpdate", { delivery_time: value })
        }
      })
      const nextName =
        returnTo === "EditDeliveryTime"
          ? "EditDeliveryTime"
          : returnTo === "BecomeSeller"
            ? "BecomeSeller"
            : "SelectDeliveryTime"
      this.$router.replace({ name: nextName, query })
    },
    syncFromRoute() {
      const { hours, days, tab } = this.$route.query || {}
      this.selectedHour = hours ? Number(hours) : null
      this.selectedDay = !hours && days ? Number(days) : null
      if (tab === "days" || tab === "hours") this.activeTab = tab
    },
  },
  mounted() {
    const tg = window.Telegram?.WebApp
    const mb = tg?.MainButton
    mb?.show()
    this.syncFromRoute()
    if (mb) {
      this.mbHandler = () => this.applyAndBack()
      mb.setText("Выбрать")
      mb.onClick(this.mbHandler)
    }
    this.updateMB()
  },
  watch: {
    activeTab() {
      this.updateMB()
    },
    selectedHour(val) {
      if (val != null) this.selectedDay = null
      this.updateMB()
    },
    selectedDay(val) {
      if (val != null) this.selectedHour = null
      this.updateMB()
    },
  },
  beforeUnmount() {
    const mb = window.Telegram?.WebApp?.MainButton
    if (mb && this.mbHandler) mb.offClick(this.mbHandler)
  },
}
</script>

<style lang="scss" module>
.page {
  position: relative;
  height: 100vh;
  background: #fff;
  padding-top: max(0.5rem, env(safe-area-inset-top));
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sheet {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.header {
  display: flex;
  margin: 0.5rem 1rem 1rem 1rem;
  position: sticky;
  top: 0;
  background: #f5f7fa;
  z-index: 2;
  overflow: hidden;
  border-radius: 0.625rem;
}
.tab {
  flex: 1;
  height: 2rem;
  border-radius: 0.5rem;
  color: #000000;
  margin: 0.125rem;
  background: transparent;
  border: none;
  font-size: 0.875rem;
  font-weight: 400;
}
.tabActive {
  background: #fff;
  color: #000000;
  border-radius: 0.5rem;
  margin: 0.125rem;
}
.list {
  flex: 1;
  overflow: auto;
  border-radius: 0.625rem;
  background: #f5f7fa;
  padding: 0.875rem 1rem 0.875rem 1rem;
  margin: 0 1rem calc(8.25rem + env(safe-area-inset-bottom)) 1rem;
  label:last-child {
    .row {
      .rowText {
        border-bottom: none;
      }
    }
  }
}
.row {
  display: grid;
  grid-template-columns: 1.25rem 1fr;
  gap: 0.75rem;
  align-items: center;
}
.vh {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
.radio {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  border: 1px solid #dbdbdf;
  background: #fff;
  display: grid;
  place-items: center;
}
.radioOn {
  border-color: #eb5a0a;
}
.dot {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background: #eb5a0a;
}
.rowText {
  font-size: 1rem;
  padding: 0.875rem 0;
  color: #161616;
  border-bottom: 1px solid #ebeaea;
}
</style>
